import { enUS } from 'date-fns/locale/en-US';
import type { Locale } from 'date-fns';
import { useMemo } from 'react';
import { Session } from 'types/listings';
import { getSortedSessionsByStartAndDuration } from 'utils/data/sessions/getSortedSessionsByStartAndDuration';
import { formatSessionTimeRange } from 'utils/dateTime';

export interface SessionTimeOption {
  label: string;
  value: string;
  original: Session;
}

export const formatSessionToSessionTimeOption = (
  session: Session,
  locale: Locale = enUS,
): SessionTimeOption => {
  const [, sessionTimePart] = session.startDateTime.split('T');
  const timeStr = sessionTimePart.substring(0, 8);
  const { startTime, endTime } = formatSessionTimeRange(
    timeStr,
    session.duration,
    locale,
  );

  return {
    label: `${startTime} - ${endTime}`,
    value: `${sessionTimePart}-${session.duration}`,
    original: session,
  };
};

export const getSessionTimeOptions = (
  sessions: Session[],
  locale: Locale = enUS,
) => {
  const orderSessionTimes = getSortedSessionsByStartAndDuration(sessions);
  let res = orderSessionTimes.map((session) =>
    formatSessionToSessionTimeOption(session, locale),
  );

  res = res.filter(
    (s1, i, all) => all.findIndex((s2) => s2.value === s1.value) === i,
  );

  return res;
};

export const useSessionTimeOptions = (
  sessions: Session[],
  locale: Locale = enUS,
) => {
  return useMemo(
    () => getSessionTimeOptions(sessions, locale),
    [sessions, locale],
  );
};
